import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconWorldPin } from "@tabler/icons-react";
import { RegionesTiendasFiltersDef } from "./RegionesTiendasFiltersDef";

export const RegionesTiendasIcon = IconWorldPin;
export const RegionesTiendasHelpText = '* Regiones Tiendas.';

export class RegionesTiendasFilters extends Entity<RegionesTiendasFiltersDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new RegionesTiendasFiltersDef(), parentKeys);
        this.Form = import('./RegionesTiendasFiltersForm').then((module) => module.RegionesTiendasFiltersForm);
        this.Title = "Regiones Tiendas";
        this.HelpText = RegionesTiendasHelpText;
        this.Icon = RegionesTiendasIcon;
    }
}